export default __webpack_public_path__ + "static/media/S_Sapato.db49d07b.svg";